import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api'
import app from '../firebase/config';
import { toast } from 'react-toastify';
export const ProductsContext = createContext({});

function ProductsProvider({ children }) {
    const [animationInsertProduct, setAnimationInsertProduct] = useState(false)
    const [product, setProduct] = useState()
    const [imagesFirebase, setImagesFirebase] = useState([])
    const [getUpdate, setGetUpdate] = useState(false)
    const [animation, setAnimation] = useState(false)
    const [products, setProducts] = useState([])
    const [productsLenght, setProductsLenght] = useState()
    const [dashboard, setDashboard] = useState()
    const [editModalShow, setEditModalShow] = useState(false)
    const [idEditProduct, setIdEditProduct] = useState()
    const [editProductData, setEditProductData] = useState()
    const [showModalConfirm, setShowModalConfirm] = useState(false)
    const [btnAnimation,setBtnAnimation] = useState(false)
    const [page,setPage] = useState(0)
    const [filterImage,setFilterImage] = useState("1")
    const [nameEdit,setNameEdit] = useState()
    const [idEdit,setIdEdit] = useState()

    
    const storageProduct = async (product, dataSheet, images) => {
        try {

            setAnimationInsertProduct(true)
            
            const storageProduct = await api.post("panel/storage/product/", {
                "name": product.name,
                "type_product": product.type_product,
                "category": product.mark_product,
                "sub_category": product.sub_category_product,
                "session_product": product.session_product,
                "type_stock": product.type_stock,
                "model": "",
                "qtd_stock": product.qtd_stock,
                "sku": product.sku,
                "barCode": product.bar_code,
                "datasheet": dataSheet,
                "weight": product.weight,
                "length": product.lenght,
                "manufacture": "3",
                "variations": "",
                "engateCategory": product.category_product,
                "description": localStorage.getItem("@CONTENT_DESCRIPTION"),
                "width": product.width,
                "height": product.height,
                "video": "0",
                "price": product.promotional_price,
                "free_shipping": product.type_shippment_product,
                "promotion_price": product.price,
            });

            if (storageProduct.status === 200) {

                const id = storageProduct.data.id;
                await storageImages(id, images)
            }

        } catch (error) {
            console.error("Erro ao armazenar produto ou imagens:", error);

        } finally {
            window.location.href = "/dashboard/products"
        }
    }
    const storageImages = async (id, images) => {

        const uploadPromises = images.map((item, index) => {
            return app.storage().ref(`/products/images/${item.name}`).put(item)
                .then(() => {
                    console.log(`Imagem ${item.name} carregada com sucesso`);
                    return app.storage().ref(`/products/images/${item.name}`).getDownloadURL();
                })
                .then(image => {
                    return api.post("panel/storage/product/image", {
                        "image": image,
                        "file_name": item.name,
                        "product_id": id,
                        "index": index
                    });
                })
                .catch(error => {
                    console.error(`Erro ao carregar a imagem ${item.name}:`, error);
                });
        });
        getAll()
        await Promise.all(uploadPromises); // Aguarde todas as promessas de upload serem concluídas


    }
    const getAll = async (image) => {
        try {
            const response = await api.get(`panel/all/products?page=${page}&image=${filterImage}`);
            if (response.status === 200) {
                setProductsLenght(String(response.data).length)
                setProducts(prev => {
                    const newProducts = response.data.products.filter(newProduct =>
                        !prev.some(existingProduct => existingProduct.id === newProduct.id)
                    );
                    return [...prev, ...newProducts];
                });
            }
        } catch (error) {
            console.error('Erro ao buscar produtos:', error);
        } finally {
        }
    };
    const getDashboard = async () => {
        const response = await api.get("products/get/dashboard")

        if (response.status == 200) {
            setDashboard({
                total: response.data.total,
                withoutDatasheet: response.data.withoutDatasheet,
                productsWithoutStock: response.data.productsWithoutStock
            })
        }

    }
    const get = async (e) => {
        setAnimation(true)
        if (e == "") {
            setAnimation(true)
            setGetUpdate(true)
            setAnimation(false)
            return
        }
        const response = await api.get(`panel/product/by/name/${e}`)
        if (response.status == 200) {
            setGetUpdate(false)
            setProducts(response.data)
            setAnimation(false)
            return
        }
        setAnimation(false)


    }
    const deleteProduct = async (id) => {

        const response = await api.delete(`panel/product/${id}`);
        if (response.status == 200) {
            toast.success(`Produto ${editProductData?.name} removido com sucesso!`, {
                autoClose: 1500
            })

            getProducts()
        }
    }
    const getProducts = async () => {
        setProducts([])
        getAll()
    }
    const update = async (field, value, id) => {

        if(field == "sub_category"){
            const product = products.filter(item => item.id == editProductData.id)
            product[0].sub_category = value
        }
        if(field == "engateCategory"){
            const product = products.filter(item => item.id == editProductData.id)
            product[0].engateCategory = value
        }
        if(field == "name"){
            const product = products.filter(item => item.id == editProductData.id)
            product[0].name = value
        }
        if(field == "price"){
            const product = products.filter(item => item.id == editProductData.id)
            product[0].price = value
        }
        
        
        const response = await api.put("panel/product/update", {
            field,
            value,
            id: editProductData.id
        });

        return toast.success(`Produto alterado com sucesso! `,{
            autoClose:1500
        })


    };
    useEffect(() => {

        getDashboard()
    }, [])

    return (
        <ProductsContext.Provider value={{
            storageProduct,
            setProduct,
            getAll,
            setImagesFirebase,
            imagesFirebase,
            get,
            products,
            dashboard,
            productsLenght,
            update,
            animation,
            getUpdate,
            animationInsertProduct,
            setIdEditProduct,
            idEditProduct,
            setEditModalShow,
            editModalShow,
            setEditProductData,
            editProductData,
            setShowModalConfirm,
            showModalConfirm,
            deleteProduct,
            getProducts,
            setBtnAnimation,
            btnAnimation,
            page,
            setPage,
            setProducts,
            products,
            setFilterImage,
            filterImage,
            nameEdit,
            idEdit
        }}>
            {children}
        </ProductsContext.Provider>
    );
}

export default ProductsProvider;
